<template>
  <div>
    <v-card tile flat>
      <v-card-title>
        <v-row no-gutters>
          <v-col cols="auto">
            Advertisers
            <!-- <small>Last Status Update:</small> -->
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="5">
            <v-text-field
              v-model="ui.advertisers.search"
              label="Search"
              single-line
              hide-details
              clearable
            >
              <template v-slot:append>
                <v-icon color="primary">mdi-magnify</v-icon>
              </template>
            </v-text-field>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="auto">
            <CreateAdvertiser v-if="role == 'ADMIN'" />
          </v-col>
          <v-btn
            color="success"
            class="ml-2"
            tile
            elevation
            height="40"
            @click="getInfo"
            :loading="isRefreshing"
            >Refresh</v-btn
          >
        </v-row>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="allAdvertisers"
        :search.sync="ui.advertisers.search"
        sort-by="name"
        :page.sync="ui.advertisers.page"
        :items-per-page.sync="ui.advertisers.perPage"
        :footer-props="{ 'items-per-page-options': [10, 30, 50, 100] }"
      >
        <template v-slot:item.name="{ item }">{{ item.name }}</template>

        <template v-slot:item.panelId="{ item }">{{
          item.panelId || "N/A"
        }}</template>
        <template v-slot:item.panelStatusText="{ item }">
          <!-- <WebStatus :status="item.panelStatus"></WebStatus> -->
          <span
            v-if="item.panelId"
            :class="[item.panelStatus ? 'success--text' : 'primary--text']"
            >{{ item.panelStatusText || "N/A" }}</span
          >
          <span v-else>N/A</span>
        </template>
        <template v-slot:item.description="{ item }">{{
          item.description
        }}</template>
        <template v-slot:item.banners="{ item }">
          {{
            item.banners.filter(
              (banner) => banner.isActive && banner.permission
            ).length
          }}
          / {{ item.banners.length }}
        </template>
        <template v-slot:item.action="{ item }">
          <v-btn
            tile
            class="primary my-4"
            width="165"
            height="60"
            text
            :to="{
              name: 'dashboard.advertisers.show',
              params: { advertiserID: item._id },
            }"
            >Show more</v-btn
          >
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
import Vue from "vue";
import { mapGetters, mapActions, mapState } from "vuex";
import { ApiService, StatusService } from "@/common/services";

export default Vue.extend({
  name: "Advertisers",
  components: {
    CreateAdvertiser: () => import("@/components/Dashboard/CreateAdvertiser"),
  },
  data() {
    return {
      isRefreshing: false,
      search: "",
      headers: [
        {
          text: "Name",
          align: "left",
          value: "name",
          width: "16.5%",
        },
        { text: "ID", value: "panelId", width: "16%" },
        { text: "Status", value: "panelStatusText", width: "16.5%" },
        { text: "Hash", value: "hash", width: "10%" },
        { text: "Description", value: "description", width: "16.5%" },
        { text: "Banners (active)", value: "banners", width: "17%" },
        { text: "", value: "action", sortable: false, align: "right" },
      ],
    };
  },

  computed: {
    ...mapGetters(["role", "getBannersByCompany"]),
    ...mapState(["ui"]),
    advertisers() {
      return this.$store.state.advertiser.advertisers;
    },
    allAdvertisers() {
      this.advertisers.forEach(
        (advertiser) =>
          (advertiser.banners = this.getBannersByCompany(advertiser._id))
      );
      return this.advertisers;
    },
  },
  methods: {
    ...mapActions(["fetchAdvertisers", "fetchBanners", "setSnackbar"]),
    async getInfo() {
      this.setSnackbar({
        text: `Fetching data....`,
        color: "warning",
        timeout: 15000,
      });
      this.isRefreshing = true;
      try {
        const { data, status: status1 } = await StatusService.get();

        // console.log(data)
        const { status: status2 } = await ApiService.post("jobs", {
          data,
          timeout:60000
        });
        this.isRefreshing = false;
        if (status1 == 200) {
          this.setSnackbar({
            text: `Advertisers fetched.`,
          });
        }

        if (status2 == 201) {
          this.setSnackbar({
            text: `Advertisers updated.`,
          });
          this.fetchAdvertisers();
        }
      } catch (error) {
        console.log(error);
        this.isRefreshing = false;
        this.setSnackbar({
          text: error.message,
          color: "error",
        });
      }
    },
  },
  mounted() {
    this.fetchBanners();
    this.fetchAdvertisers();
  },
});
</script>

<style lang="scss">
.nav-link.btn {
  padding: 0.2em 0.5em;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #ef3f37;
  cursor: pointer;
  color: #ef3f37;
  text-decoration: none;
  font-size: 18px;
  font-weight: 600;
  margin: 0 10px 10px 0;
  transition-property: border-color, color;
  transition-duration: 200ms;
  &:hover {
    background-color: rgba(239, 64, 55, 0.06);
    // color: #c1263e;
    // border-color: #c1263e;
  }
}
.v-data-table-header th {
  border-bottom: 2px solid #ef3f37 !important;
}
li {
  list-style: none;
  margin: 0 0 0.5em;
  padding: 0.5em 0;
  h2 {
    display: inline;
    margin-right: 0.5em;
  }
  span {
    margin-right: 1em;
  }
  button {
    margin: 0 0.25em;
  }
}
</style>
